import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import GoogleButton, { googleEnabled } from '../components/GoogleButton';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function AuthField({ label, type = 'text', placeholder, value, onChange }) {
  return (
    <div className="card col gap-2" style={{ padding: 14 }}>
      <span className="mono" style={{ color: 'var(--text-3)' }}>{label}</span>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required
        style={{
          flex: 1, background: 'transparent', border: 0, outline: 'none', minWidth: 0,
          color: 'var(--text)', fontSize: 14, fontFamily: 'inherit',
        }}
      />
    </div>
  );
}

function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('code');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, { email, password });
      onLogin(response.data.token, response.data.user);
      navigate(inviteCode ? `/rejoindre/${inviteCode}` : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async (credential) => {
    setError('');
    try {
      const res = await axios.post(`${API_URL}/api/auth/google`, { credential });
      onLogin(res.data.token, res.data.user);
      navigate(res.data.profileComplete ? (inviteCode ? `/rejoindre/${inviteCode}` : '/dashboard') : '/completer-profil');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion Google');
    }
  };

  return (
    <div className="screen" style={{ background: 'var(--ink)', minHeight: '100vh' }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: '8px 24px 40px', overflowY: 'auto' }}>

        {/* Logo */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 32, marginBottom: 28 }}>
          <div style={{
            width: 72, height: 72, borderRadius: 20, position: 'relative', overflow: 'hidden',
            background: 'linear-gradient(160deg, #F5A623 0%, #E5503E 60%, #6B2D7A 100%)',
            boxShadow: '0 12px 36px rgba(229,80,62,0.35)',
          }}>
            <svg viewBox="0 0 60 60" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
              <g fill="rgba(255,211,122,0.95)">
                <rect x="22" y="14" width="16" height="4" />
                <rect x="18" y="18" width="24" height="4" />
                <rect x="14" y="22" width="32" height="4" />
                <rect x="14" y="26" width="32" height="4" />
                <rect x="18" y="30" width="24" height="4" />
                <rect x="22" y="34" width="16" height="4" />
              </g>
            </svg>
          </div>
          <div className="display" style={{ fontSize: 48, marginTop: 16, lineHeight: 0.9 }}>Spike</div>
        </div>

        {error && (
          <div style={{
            padding: '10px 14px', borderRadius: 10, marginBottom: 16,
            background: 'rgba(229,80,62,0.1)', color: '#E5503E',
            fontSize: 13, fontWeight: 600, border: '1px solid rgba(229,80,62,0.25)',
          }}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <AuthField label="E-mail" placeholder="prenom@spike.fr" type="email"
            value={email} onChange={(e) => setEmail(e.target.value)} />
          <AuthField label="Mot de passe" placeholder="••••••••" type="password"
            value={password} onChange={(e) => setPassword(e.target.value)} />

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Link to="/forgot-password" style={{
              color: 'var(--text-3)', fontSize: 12, fontWeight: 600, padding: '4px 0',
              textDecoration: 'none',
            }}>Mot de passe oublié ?</Link>
          </div>

          <button type="submit" disabled={loading} className="btn btn-primary"
            style={{ width: '100%', marginTop: 8, padding: '15px 20px' }}>
            {loading ? 'Connexion en cours…' : 'Se connecter'}
          </button>
        </form>

        {googleEnabled && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '20px 0' }}>
              <div style={{ flex: 1, height: 1, background: 'var(--line)' }} />
              <span style={{ color: 'var(--text-3)', fontSize: 12 }}>ou</span>
              <div style={{ flex: 1, height: 1, background: 'var(--line)' }} />
            </div>
            <GoogleButton onCredential={handleGoogle} text="signin_with" />
          </>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 28, gap: 6 }}>
          <span style={{ color: 'var(--text-3)', fontSize: 13 }}>Pas encore de compte ?</span>
          <Link to={inviteCode ? `/register?code=${inviteCode}` : '/register'}
            style={{ color: 'var(--sun)', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
            Inscris-toi
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
